import React from 'react';

interface IMeterCardProps {
  title: string;
  price1: string;
  price2: string;
  price3: string;
  price4: string;
  priceBundle?: string;
  interval: string;
  subtitle: string;
  features: any;
  subData: any;
  setMgmtOpen: any;
  setEditOpen: any;
  setCancelOpen: any;
  setRenewOpen: any;
  active: boolean;
}

const MeterCard: React.FC<IMeterCardProps> = ({
  title,
  price1,
  price2,
  price3,
  price4,
  priceBundle,
  interval,
  subtitle,
  features,
  subData,
  setMgmtOpen,
  setEditOpen,
  setCancelOpen,
  setRenewOpen,
  active
}) => {
  return (
    <div className='meter-card-container'>
      <div className='meter-card-header'>
        <div className='meter-card-header-frame'>

          <div className='meter-card-title'>
            <div className='meter-card-title-text'>
              {title}
            </div>
            <div className='meter-card-badge'>
              {subData.active && subData.willCancel === null && (
                <>
                  <svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8' fill='none'>
                    <circle cx='4' cy='4' r='3' fill='#17B26A'/>
                  </svg>
                  <div className='meter-card-badge-status'>
                  Active
                  </div>
                </>
              )}
              {subData.active && subData.willCancel !== null && (
                <>
                  <svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8' fill='none'>
                    <circle cx='4' cy='4' r='3' fill='#F04438'/>
                  </svg>
                  <div className='meter-card-badge-status'>
                  Cancels on {subData.willCancel}
                  </div>
                </>
              )}
              {!subData.active && (
                <>
                  <svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8' fill='none'>
                    <circle cx='4' cy='4' r='3' fill='#85888E'/>
                  </svg>
                  <div className='meter-card-badge-status'>
                  Inactive
                  </div>
                </>
              )}
            </div>
          </div>
          {!priceBundle ? <div className='meter-card-price'>
            <div className='meter-card-price-text-row'>
              <div className='meter-card-price-text-head'>
              Monthly Volume
              </div>
              <div className='meter-card-price-text-head'>
              Price Per Call
              </div>
            </div>

            <div className='meter-card-price-text-row'>
              <div className='meter-card-price-text'>
              First 99
              </div>
              <div className='meter-card-price-text'>
              Free
              </div>
            </div>

            <div className='meter-card-price-text-row'>
              <div className='meter-card-price-text'>
              100 - 9,999
              </div>
              <div className='meter-card-price-text'>
              ${price1}
              </div>
            </div>

            <div className='meter-card-price-text-row'>
              <div className='meter-card-price-text'>
              10,000 - 49,999
              </div>
              <div className='meter-card-price-text'>
              ${price2}
              </div>
            </div>

            <div className='meter-card-price-text-row'>
              <div className='meter-card-price-text'>
              50,000 - 74,999
              </div>
              <div className='meter-card-price-text'>
              ${price3}
              </div>
            </div>

            <div className='meter-card-price-text-row'>
              <div className='meter-card-price-text'>
              75,000 - 100,000
              </div>
              <div className='meter-card-price-text'>
              ${price4}
              </div>
            </div>
          </div> : <div className='meter-card-price-bundle'>
            <div className='meter-card-price-text-bundle'>
              ${priceBundle} Per Month
            </div>

          </div>}
        </div>
      </div>
      <div className='meter-card-content'>
        <div className='meter-card-subheader'>
          <div className='meter-card-subtitle'>
            {subtitle}
          </div>
        </div>
        <div className='meter-card-body-features'>
          <div className='meter-card-body-item'>
            <div className='meter-card-body-check'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='meter-card-body-item-wrap'>
              <div className='meter-card-body-item-text'>
                {features[0]}
              </div>
            </div>
          </div>
          <div className='meter-card-body-item'>
            <div className='meter-card-body-check'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='meter-card-body-item-wrap'>
              <div className='meter-card-body-item-text'>
                {features[1]}
              </div>
            </div>
          </div>
          <div className='meter-card-body-item'>
            <div className='meter-card-body-check'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='meter-card-body-item-wrap'>
              <div className='meter-card-body-item-text'>
                {features[2]}
              </div>
            </div>
          </div>
        </div>
        {!active && (
          <div className='meter-card-body-action-btn' style={{ background: '#4A4C51' }}>
            <div className='meter-card-body-action-btn-text' style={{ color: '#BDBEC1' }}>
              Coming Soon!
            </div>
          </div>
        )}
        {subData.active && subData.willCancel && active && (
          <div className='meter-card-body-action-btn' onClick={() => setRenewOpen(true)}>
            <div className='meter-card-body-action-btn-text'>
              Re-activate
            </div>
          </div>
        )}
        {!subData.active && active && (
          <div className='meter-card-body-action-btn' onClick={() => setMgmtOpen(true)}>
            <div className='meter-card-body-action-btn-text'>
              Activate
            </div>
          </div>
        )}
        {subData.active && subData.willCancel === null && active && (
          <div className='meter-card-action-group'>
            <div className='meter-card-group-btn' onClick={() => setEditOpen(true)}>
              <div className='meter-card-group-btn-text'>
                Edit Plan
              </div>
            </div>
            <>
              {subData.subType === 'metered' ? (
                <div className='meter-card-group-btn' onClick={() => setCancelOpen({ active: true, cancelNow: true })}>
                  <div className='meter-card-group-btn-text'>
                    Cancel
                  </div>
                </div>
              ) : (
                <div className='meter-card-group-btn' onClick={() => setCancelOpen({ active: true, cancelNow: false })}>
                  <div className='meter-card-group-btn-text'>
                    Cancel
                  </div>
                </div>
              )}
            </>
          </div>
        )}
      </div>
    </div>
  );
};

export default MeterCard;
